import { styled } from '@mui/material';

import emptyImage from './empty.svg';

export const Root = styled('div')({
  textAlign: 'center',
  flex: '1 1 0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'stretch',
  alignItems: 'center',
  maxHeight: 600,
});

export const ImageWrap = styled('div')({
  width: '100%',
  maxWidth: 414,
  justifyContent: 'center',
  marginTop: 10,
  marginBottom: 10,
});

export const Image = styled('div')({
  paddingTop: '66.42512077%',
  background: `url(${emptyImage}) no-repeat center center`,
  backgroundSize: 'contain',
});
